(() => {
  const root = String(window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  async function check(path) {
    const url = new URL(root + path, location.origin);
    url.searchParams.set('view', 'ornata-access');
    url.searchParams.set('_release_check', String(Date.now()));
    const response = await fetch(url, {credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(10000)});
    const data = await response.json().catch(() => null);
    if (!response.ok || typeof data?.allowed !== 'boolean') throw new Error('De membertoegang kon niet worden gecontroleerd. Probeer opnieuw.');
    if (!data.allowed) throw new Error('Je account heeft nog geen toegang tot een exclusief product. Log in met het juiste memberaccount of verwijder het product uit je winkelwagen.');
  }
  function showError(form, error) {
    if (error.sampleCart && document.querySelector('[data-sample-cart-line]:not([hidden])') && !form.closest('dialog')) return;
    let notice = form.querySelector('[data-ornata-release-error]');
    if (!notice) {
      notice = document.createElement('p');
      notice.dataset.ornataReleaseError = '';
      notice.setAttribute('role', 'alert');
      notice.className = 'prose';
      form.append(notice);
    }
    notice.textContent = error.message;
  }
  window.OrnataReleaseAccess = {
    cart: async () => {
      if (!window.OrnataSampleCart) throw new Error('De voorraadcontrole wordt nog geladen. Probeer opnieuw.');
      await window.OrnataSampleCart.requireValid();
      return check('cart');
    },
    product: handle => check('products/' + encodeURIComponent(handle)),
  };
  // A countdown is informative only. Fetch fresh server access before refreshing
  // purchase controls; a visitor's clock can never unlock them locally.
  const releaseChecks = new Map();
  let refreshing = false;
  class OrnataReleaseCountdown extends HTMLElement {
    connectedCallback() {
      if (this.clock) return;
      const target = Number(this.dataset.availableAt), serverNow = Number(this.dataset.serverNow);
      if (!target || !serverNow) return;
      this.startedAt ??= performance.now();
      const date = this.querySelector('[data-release-date]');
      if (date) date.textContent = new Intl.DateTimeFormat('nl-NL', {
        timeZone: 'Europe/Amsterdam', day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit',
      }).format(new Date(target * 1000));
      const tick = () => {
        const remaining = Math.max(0, Math.ceil(target - serverNow - (performance.now() - this.startedAt) / 1000));
        for (const [key, value] of Object.entries({days: Math.floor(remaining / 86400), hours: Math.floor(remaining % 86400 / 3600), minutes: Math.floor(remaining % 3600 / 60), seconds: remaining % 60})) {
          const element = this.querySelector(`[data-release-${key}]`);
          if (key === 'days') {
            if (element) element.hidden = value === 0;
            const unit = this.querySelector('[data-release-days-unit]');
            if (unit) unit.hidden = value === 0;
          }
          const text = key === 'days' ? String(value) : String(value).padStart(2, '0');
          if (element && element.textContent !== text) {
            if (element.firstChild?.nodeType === Node.TEXT_NODE) element.firstChild.nodeValue = text;
            else element.textContent = text;
          }
        }
        if (!remaining) { this.disconnectedCallback(); void this.refreshAccess(); }
      };
      this.clock = setInterval(tick, 1000);
      tick();
    }
    disconnectedCallback() { clearInterval(this.clock); this.clock = null; }
    async refreshAccess() {
      if (this.checked || !this.dataset.productHandle) return;
      this.checked = true;
      const status = this.querySelector('[data-release-status]');
      const timer = this.querySelector('[data-release-timer]');
      if (timer) timer.hidden = true;
      if (status) { status.hidden = false; status.textContent = 'Beschikbaarheid controleren…'; }
      try {
        const handle = this.dataset.productHandle;
        if (!releaseChecks.has(handle)) releaseChecks.set(handle, window.OrnataReleaseAccess.product(handle));
        await releaseChecks.get(handle);
        if (this.isConnected && !refreshing) { refreshing = true; location.reload(); }
      } catch {
        if (status) status.textContent = 'Vernieuw de pagina voor de actuele beschikbaarheid.';
        const link = this.querySelector('[data-release-refresh]');
        if (link) link.hidden = false;
      }
    }
  }
  if (!customElements.get('ornata-release-countdown')) customElements.define('ornata-release-countdown', OrnataReleaseCountdown);
  // Re-submit through the existing checkout/credits handlers after the server
  // check. This is a theme UX guard, not a native checkout validation Function.
  const passed = new WeakSet(), pending = new WeakSet();
  window.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.querySelector('[name="checkout"]')) return;
    if (event.submitter && event.submitter.name !== 'checkout') return;
    if (passed.has(form)) { passed.delete(form); return; }
    event.preventDefault(); event.stopImmediatePropagation();
    if (pending.has(form)) return;
    pending.add(form);
    try {
      await window.OrnataReleaseAccess.cart();
      form.querySelector('[data-ornata-release-error]')?.remove();
      if (form.isConnected) {
        passed.add(form);
        form.requestSubmit(event.submitter?.isConnected ? event.submitter : undefined);
      }
    } catch (error) { showError(form, error); }
    finally { pending.delete(form); }
  }, true);
})();

